(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DaisyPebblePictureCartModel = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function integer(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function countLabel(count, people) {
    // Opt-in people.countSuffix (e.g. '' for angels, whose counts are plain numbers).
    if (people && typeof people.countSuffix === 'string') return String(count) + people.countSuffix;
    return String(count) + ' (Inc dog/cat)';
  }

  function selectedCount(state, config, offer) {
    var people = config.people || {};
    if (people.mode === 'fixed') return integer(people.count, 2);
    var min = integer(people.min, 1);
    var max = integer(people.max, 8);
    var raw = offer ? state.offerPeopleCount : state.peopleCount;
    return Math.max(min, Math.min(max, integer(raw, min)));
  }

  function addConfiguredFields(properties, values, fields) {
    (fields || []).forEach(function (field) {
      var value = clean(values[field.source || field.key]);
      if (field.changeKey) {
        var isDefault = value === clean(field.default || '');
        properties[field.changeKey] = isDefault ? (field.noValue || 'NO') : (field.yesValue || 'YES');
        if (!isDefault && value) properties[field.key] = value;
      } else if (value) {
        properties[field.key] = value;
      }
    });
  }

  function addPeopleProperties(properties, state, config, offer) {
    var people = config.people || {};
    var count = selectedCount(state, config, offer);
    var pebbles = offer ? state.offerPebbles : state.pebbles;
    var names = offer ? state.offerNames : state.names;

    if (people.mode === 'variable') {
      properties[offer ? people.offerCountKey || '(Offer) ' + people.countKey : people.countKey] = countLabel(count, people);
      var extras = (offer ? state.offerExtras : state.extras) || [];
      for (var index = 0; index < count; index += 1) {
        (people.personSelects || []).forEach(function (ps, k) {
          var extraValue = clean((extras[k] || [])[index]);
          if (extraValue) properties[(offer ? ps.offerPrefix || '(Offer) ' + ps.prefix : ps.prefix) + (index + 1)] = extraValue;
        });
        var value = clean((pebbles || [])[index]);
        if (value) {
          var prefix = offer ? people.offerFieldPrefix || '(Offer) ' + people.fieldPrefix : people.fieldPrefix;
          properties[prefix + (index + 1)] = value;
        }
        if (people.names) {
          var nameValue = clean((names || [])[index]);
          if (nameValue) {
            var namePrefix = offer ? people.offerNamePrefix || '(Offer) ' + (people.namePrefix || 'Name ') : (people.namePrefix || 'Name ');
            properties[namePrefix + (index + 1)] = nameValue;
          }
        }
      }
    } else if (people.mode === 'weddingfamily') {
      var wfCountKey = offer ? (people.offerCountKey || '(Offer) ' + people.countKey) : people.countKey;
      properties[wfCountKey] = String(count);
      var fixedCount = integer(people.fixedCount, 2);
      var fixedOption = (people.fixedOptions || ['Bride/Groom'])[0];
      var wfPrefix = offer ? (people.offerFieldPrefix || '(Offer) Pebble ') : (people.fieldPrefix || 'Pebble ');
      for (var fi = 0; fi < fixedCount; fi += 1) {
        properties[wfPrefix + (fi + 1)] = fixedOption;
      }
      for (var vi = 0; vi < count - fixedCount; vi += 1) {
        var wfVal = clean((pebbles || [])[vi]);
        if (wfVal) properties[wfPrefix + (fixedCount + vi + 1)] = wfVal;
        if (people.names) {
          var wfNameValue = clean((names || [])[vi]);
          if (wfNameValue) {
            var wfNamePrefix = offer ? people.offerNamePrefix || '(Offer) ' + (people.namePrefix || 'Name ') : (people.namePrefix || 'Name ');
            properties[wfNamePrefix + (fixedCount + vi + 1)] = wfNameValue;
          }
        }
      }
    }
  }

  function baseProperties(state, config, bundleId) {
    var properties = {
      '_Bundle ID': bundleId,
      '_Custom option flow': 'Daisy native pebble picture options'
    };
    addConfiguredFields(properties, state.values || {}, config.fields);
    addPeopleProperties(properties, state, config, false);
    if (config.secondOffer && config.secondOffer.key) {
      properties[config.secondOffer.key] = state.secondFrame ? config.secondOffer.yes : config.secondOffer.no;
    }
    return properties;
  }

  function offerProperties(state, config, bundleId) {
    var properties = {
      '_Bundle ID': bundleId,
      '_Linked product': config.title
    };
    addConfiguredFields(properties, state.offerValues || {}, config.offerFields);
    addPeopleProperties(properties, state, config, true);
    return properties;
  }

  function extraPeopleItem(state, config, bundleId, offer) {
    if (!config.extraPeople) return null;
    var count = selectedCount(state, config, offer);
    if (count <= integer(config.extraPeople.threshold, 6)) return null;
    return {
      id: config.extraPeople.variantId,
      quantity: 1,
      linePrice: config.extraPeople.price,
      properties: {
        '_Bundle ID': bundleId,
        '_Linked product': config.title,
        'Add-on': config.extraPeople.property || 'Extra pebble people',
        'For': offer ? 'Second frame' : 'Main frame'
      }
    };
  }

  function buildCartItems(state, config, bundleId) {
    var items = [{
      id: config.variantId,
      quantity: 1,
      linePrice: config.prices.base,
      properties: baseProperties(state, config, bundleId)
    }];

    var mainExtra = extraPeopleItem(state, config, bundleId, false);
    if (mainExtra) items.push(mainExtra);

    if (state.secondFrame && config.secondOffer) {
      items.push({
        id: config.secondOffer.variantId,
        quantity: 1,
        linePrice: config.secondOffer.price,
        properties: offerProperties(state, config, bundleId)
      });
      var offerExtra = extraPeopleItem(state, config, bundleId, true);
      if (offerExtra) items.push(offerExtra);
    }

    return items;
  }

  function calculateTotal(state, config) {
    var current = buildCartItems(state, config, 'total-preview').reduce(function (sum, item) {
      return sum + item.linePrice;
    }, 0);
    var compareAt = config.prices.compareAt > config.prices.base ? current + (config.prices.compareAt - config.prices.base) : null;
    return { current: current, compareAt: compareAt };
  }

  // Opt-in checks: people.namesRequired (a name for every shown pebble) and
  // people.personSelects entries (required unless required === false).
  function optInPeopleMissing(missing, state, config, offer) {
    var people = config.people || {};
    var count = selectedCount(state, config, offer);
    var extras = (offer ? state.offerExtras : state.extras) || [];
    var names = (offer ? state.offerNames : state.names) || [];
    for (var index = 0; index < count; index += 1) {
      (people.personSelects || []).forEach(function (ps, k) {
        if (ps.required !== false && !clean((extras[k] || [])[index])) {
          missing.push((offer ? ps.offerPrefix || '(Offer) ' + ps.prefix : ps.prefix) + (index + 1));
        }
      });
      if (people.names && people.namesRequired && !clean(names[index])) {
        missing.push((offer ? people.offerNamePrefix || '(Offer) ' + (people.namePrefix || 'Name ') : (people.namePrefix || 'Name ')) + (index + 1));
      }
    }
  }

  function validate(state, config) {
    var missing = [];
    (config.fields || []).forEach(function (field) {
      if (field.required && !clean((state.values || {})[field.key])) {
        missing.push(field.key);
      } else if (field.changeKey) {
        var v = clean((state.values || {})[field.key]);
        if (v !== clean(field.default || '') && !v) missing.push(field.key);
      }
    });
    if ((config.people || {}).mode === 'variable') {
      var count = selectedCount(state, config, false);
      for (var index = 0; index < count; index += 1) {
        if (!clean((state.pebbles || [])[index])) missing.push((config.people.fieldPrefix || 'Pebble ') + (index + 1));
      }
      optInPeopleMissing(missing, state, config, false);
    }
    if ((config.people || {}).mode === 'weddingfamily') {
      var wfCount = selectedCount(state, config, false);
      var wfFixed = integer((config.people || {}).fixedCount, 2);
      for (var wi = 0; wi < wfCount - wfFixed; wi += 1) {
        if (!clean((state.pebbles || [])[wi])) {
          missing.push(((config.people || {}).fieldPrefix || 'Pebble ') + (wfFixed + wi + 1));
        }
      }
    }
    if (state.secondFrame) {
      (config.offerFields || []).forEach(function (field) {
        if (field.required && !clean((state.offerValues || {})[field.source || field.key])) {
          missing.push(field.key);
        } else if (field.changeKey) {
          var ov = clean((state.offerValues || {})[field.source || field.key]);
          if (ov !== clean(field.default || '') && !ov) missing.push(field.key);
        }
      });
      if ((config.people || {}).mode === 'variable') {
        var offerCount = selectedCount(state, config, true);
        for (var offerIndex = 0; offerIndex < offerCount; offerIndex += 1) {
          if (!clean((state.offerPebbles || [])[offerIndex])) missing.push((config.people.offerFieldPrefix || '(Offer) Pebble ') + (offerIndex + 1));
        }
        optInPeopleMissing(missing, state, config, true);
      }
      if ((config.people || {}).mode === 'weddingfamily') {
        var wfOfferCount = selectedCount(state, config, true);
        var wfOfferFixed = integer((config.people || {}).fixedCount, 2);
        for (var woi = 0; woi < wfOfferCount - wfOfferFixed; woi += 1) {
          if (!clean((state.offerPebbles || [])[woi])) {
            missing.push(((config.people || {}).offerFieldPrefix || '(Offer) Pebble ') + (wfOfferFixed + woi + 1));
          }
        }
      }
    }
    return missing;
  }

  return {
    buildCartItems: buildCartItems,
    calculateTotal: calculateTotal,
    validate: validate
  };
});
